import { TextField } from "@mui/material";
import { useField } from "formik";

const locationPinMapLinkGuidance =
  "Link to a map image with a pin marking the project location.";

function LocationPinMapLinkField() {
  const [field, meta] = useField<string>("location-pin-map-link");
  const hasError = meta.touched && Boolean(meta.error);

  return (
    <TextField
      id="location-pin-map-link"
      label="Location Pin Map Link"
      variant="standard"
      fullWidth
      autoComplete="disabled"
      name={field.name}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      error={hasError}
      helperText={hasError ? meta.error : locationPinMapLinkGuidance}
    />
  );
}

export default LocationPinMapLinkField;
